// Helpers shared by the Planner and the Sound Lab: preset lists by role and family, kit labels.
import {
  getPreset,
  INSTRUMENT_ROLES,
  KIT_IDS,
  KITS,
  pickAlternates,
  SYNTH_PRESETS,
  type InstrumentRole,
  type KitId,
  type SynthPreset,
} from "@eb/shared";

export const ROLE_LABEL: Record<InstrumentRole, string> = {
  bass: "Bass",
  harmony: "Chords",
  lead: "Lead",
  classic: "Classics",
};

/** Presets of a role grouped by family (families in list order). */
export function familiesOf(role: InstrumentRole): { family: string; presets: SynthPreset[] }[] {
  const out = new Map<string, SynthPreset[]>();
  for (const p of SYNTH_PRESETS) if (p.role === role) out.set(p.family, [...(out.get(p.family) ?? []), p]);
  return [...out.entries()].map(([family, presets]) => ({ family, presets }));
}

export const kitLabel = (k: KitId) =>
  KITS[k].genre === KITS[k].name ? KITS[k].name : `${KITS[k].name} — ${KITS[k].genre}`;
export const KIT_OPTIONS = KIT_IDS.map((k) => ({ id: k, label: kitLabel(k) }));

/** Default alternates for a main preset: two of its family. */
export function defaultAlternates(id: string, seed = 0): [string, string] {
  try {
    return pickAlternates(id, seed);
  } catch {
    return [id, id];
  }
}

export function presetLabel(id: string): string {
  const p = getPreset(id);
  return `${p.name}${p.alternateOnly ? "" : " ★"}`;
}

export { INSTRUMENT_ROLES };
